import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Text } from 'components/core/Typography';
import { getNumericalValue } from 'utils/format';

import FeeWarningToolTipV2 from 'components/fees/FeeWarningToolTipV2';

import './unitPriceV2.scss';

export const enhance = withProps(({ price }) => {
	const [dollars, cents] = price.toString().split('.');

	// Adds Support for Component Caching which requires flattened, pre-formatted props
	return {
		priceValue: parseFloat(price.replace(/,/g, '')),
		priceDollars: dollars,
		priceCents: cents || '00',
	};
});

export class UnitPriceV2 extends PureComponent {
	static propTypes = {
		priceValue: PropTypes.number,
		/** The regular price of a unit, if provided it is shown with a strikethrough */
		regularPrice: PropTypes.string,
		/** If the price text should be a link */
		linkedPrice: PropTypes.bool,
		showPeriod: PropTypes.bool,
		link: PropTypes.string,
		size: PropTypes.string,
		priceDollars: PropTypes.string.isRequired,
		priceCents: PropTypes.string.isRequired,
		isScarce: PropTypes.bool,
		unitQuantity: PropTypes.number,
		showFees: PropTypes.bool,
		fees: PropTypes.object,
	};

	static defaultProps = {
		linkedPrice: true,
		showPeriod: false,
		size: 'medium',
		showFees: false,
		fees: {},
	};

	_renderPrice() {
		const { priceDollars, priceCents } = this.props;
		if (!this.props.linkedPrice) {
			return (
				<Text
					className={classnames('price', {
						'price-scarcity': this.props.isScarce,
					})}
					size={this.props.size}
					last
				>
					${priceDollars}.{priceCents}
				</Text>
			);
		}

		return (
			<Link
				href={this.props.link}
				className="price-content"
				hideBorder
			>
				<Text
					className={classnames('price', {
						'price-scarcity': this.props.isScarce,
					})}
					strong
					size={this.props.size}
				>
					${priceDollars}.{priceCents}
				</Text>
			</Link>
		);
	}

	_renderRegularPrice() {
		const { regularPrice, priceValue } = this.props;
		if (!regularPrice || getNumericalValue(regularPrice) <= priceValue) {
			return null;
		}

		return (
			<Text
				className="regular-price"
				strikethrough
				last
			>
				${regularPrice}
			</Text>
		);
	}

	_renderPeriod() {
		if (!this.props.showPeriod) {
			return null;
		}

		return (
			<Text
				className="payment-period"
				last
			>
				per month
			</Text>
		);
	}

	_renderFees() {
		if (!this.props.showFees || !this.props?.fees?.totalFees?.value) {
			return null;
		}

		return (
			<FeeWarningToolTipV2
				feeProps={this.props.fees}
				className="fee-tooltip"
			/>
		);
	}

	render() {
		const hasRegularPrice = this._renderRegularPrice();

		return (
			<div className="unit-price-content">
				<div className='unit-price'>
					{hasRegularPrice}
					{this._renderPrice()}
					<div className="scarcity-and-price-content">
						{this.props.isScarce && (
							<Text
								className="scarcity-message-content"
								last
							>
								ONLY {this.props.unitQuantity} LEFT!
							</Text>
						)}
					</div>
				</div>
				{this._renderFees()}
				{/* {this._renderPeriod()} */}
			</div>
		);
	}
}
export default enhance(UnitPriceV2);
